// extracted by mini-css-extract-plugin
export default {"genericCard":"er-z","inline":"fr-z","mastercard":"gr-z","discover":"hr-z","visa":"ir-z","amex":"jr-z","active":"kr-z"};